// extracted by mini-css-extract-plugin
module.exports = {"addMore":"addMore--2INL8"};